// Fallback del menú cuando no hay un rol reconocido en sesión.
// La fuente única de los menús por rol vive en src/app/layouts/menus/.
export { navItemsAdministrativeDirection as navItems } from '../../../menus';
